const commentItems = [
  {
    avatar: 'https://readdy.ai/api/search-image?query=Abstract%20mysterious%20avatar%20with%20dark%20red%20tones%2C%20minimalist%20geometric%20face%20silhouette%2C%20dark%20background%2C%20warm%20crimson%20accents%2C%20modern%20clean%20design&width=120&height=120&seq=avatar-01&orientation=squarish',
    name: '吃瓜一线记者',
    time: '3分钟前',
    content: '这个瓜我全程跟了！从最初的蛛丝马迹到现在的实锤，暗网吃瓜论坛上的分析帖子真的太牛了，每条线索都对得上。建议大家都去看看原帖，信息量巨大！',
    likes: '2.3万',
    tag: '资深瓜友',
  },
  {
    avatar: 'https://readdy.ai/api/search-image?query=Abstract%20dark%20amber%20toned%20avatar%2C%20minimalist%20face%20silhouette%2C%20warm%20golden%20highlights%20on%20dark%20background%2C%20mysterious%20vibe%2C%20clean%20modern%20design&width=120&height=120&seq=avatar-02&orientation=squarish',
    name: '匿名爆料人',
    time: '15分钟前',
    content: '我就是这个行业的内部人员，只能说帖子里说的都是真的，甚至还有更多没爆出来的。有些事不是不报，时候未到。吃瓜群里的老铁们等着看吧。',
    likes: '1.8万',
    tag: '知情人',
  },
  {
    avatar: 'https://readdy.ai/api/search-image?query=Abstract%20dark%20rose%20toned%20avatar%2C%20minimalist%20female%20silhouette%2C%20soft%20crimson%20glow%20on%20dark%20background%2C%20mysterious%20elegant%20design&width=120&height=120&seq=avatar-03&orientation=squarish',
    name: '深夜吃瓜人',
    time: '28分钟前',
    content: '大半夜刷到这个根本睡不着了！暗网吃瓜的爆料速度是真的快，别的平台还在转二手消息的时候，这边已经扒到第三层了。这就是我每天都刷的原因。',
    likes: '1.2万',
    tag: '活跃用户',
  },
];

export default function Comments() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-100">
      <div className="px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="flex items-center gap-3 mb-10">
          <div className="w-1 h-7 bg-primary-500 rounded-full"></div>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-100">
            瓜友热议
          </h2>
          <span className="text-xs text-foreground-500 mt-1">精选优质评论</span>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {commentItems.map((item, idx) => (
            <div
              key={idx}
              className="bg-background-200 rounded-xl p-5 md:p-6 flex flex-col"
            >
              <div className="flex items-start gap-3 mb-4">
                <div className="w-10 h-10 rounded-full overflow-hidden flex-shrink-0">
                  <img
                    src={item.avatar}
                    alt={item.name}
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2 flex-wrap">
                    <span className="text-sm font-medium text-foreground-300 whitespace-nowrap">{item.name}</span>
                    <span className="px-2 py-0.5 bg-primary-500/15 text-primary-400 text-xs rounded-md whitespace-nowrap">{item.tag}</span>
                  </div>
                  <span className="text-xs text-foreground-600">{item.time}</span>
                </div>
              </div>

              <p className="text-sm text-foreground-400 leading-relaxed flex-1 mb-4">
                "{item.content}"
              </p>

              <div className="flex items-center gap-3 text-xs text-foreground-600">
                <span className="flex items-center gap-1 cursor-pointer hover:text-primary-400 transition-colors whitespace-nowrap">
                  <i className="ri-heart-line"></i>
                  {item.likes}
                </span>
                <span className="flex items-center gap-1 cursor-pointer hover:text-primary-400 transition-colors whitespace-nowrap">
                  <i className="ri-chat-1-line"></i>
                  回复
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}